var cifWs = ["301 151", "<g fill='none'><path fill='#CE1126' d='M.5.5h300v150H.5z'/><path fill='#002B7F' d='M.5.5h150v75H.5z'/><path fill='#FFF' d='M75.5 52.561l6.438 19.814-16.855-12.246h20.834L69.062 72.375zM52.584 22.375L57.734 38 44.25 28.343h16.667L47.433 38zM98.938 19.25l4.828 14.583-12.641-9.013h15.625l-12.641 9.013zM75.5 3.625l5.151 15.625-13.484-9.657h16.667L70.35 19.25zM86.959 38.51l3.218 9.906-8.427-6.122h10.417l-8.427 6.122z'/></g>"];

export { cifWs };

